import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import TopNavigator from "../components/TopNavigator";
import { fetchUserPortalDetails } from "../utils/userPortalApi";

function isUserLoggedIn() {
  return Boolean(localStorage.getItem("token") && localStorage.getItem("user"));
}

function SupportIcon({ type }) {
  const icons = {
    phone: (
      <path d="M7.2 4.75 9.35 4.3a1.45 1.45 0 0 1 1.65.84l.98 2.29a1.45 1.45 0 0 1-.42 1.68l-1.18.99a11.2 11.2 0 0 0 3.52 3.52l.99-1.18a1.45 1.45 0 0 1 1.68-.42l2.29.98a1.45 1.45 0 0 1 .84 1.65l-.45 2.15a2.2 2.2 0 0 1-2.43 1.75C10.4 18.26 5.74 13.6 4.95 6.98A2.2 2.2 0 0 1 7.2 4.75Z" />
    ),
    whatsapp: (
      <>
        <path d="M5.1 19.25 6.25 16.3a7.25 7.25 0 1 1 2.62 2.28L5.1 19.25Z" />
        <path d="M9.3 8.7c.2-.42.38-.42.63-.42h.45c.15 0 .36.06.55.45.2.47.68 1.65.74 1.77.06.13.1.29.02.46-.08.18-.13.29-.26.44l-.38.43c-.13.13-.27.27-.12.53.15.27.66 1.08 1.42 1.75.98.87 1.8 1.14 2.07 1.27.27.14.42.12.58-.07l.66-.77c.17-.26.36-.22.61-.13.25.08 1.58.74 1.85.87.27.13.45.2.52.31.06.12.06.68-.16 1.33-.22.64-1.27 1.23-1.77 1.28-.46.05-1.05.07-1.7-.11-.39-.13-.9-.29-1.55-.57-2.72-1.18-4.5-3.92-4.64-4.1-.14-.18-1.1-1.46-1.1-2.78 0-1.32.7-1.97.95-2.24Z" />
      </>
    ),
    sms: (
      <>
        <path d="M5.75 6.25h12.5A2.25 2.25 0 0 1 20.5 8.5v7A2.25 2.25 0 0 1 18.25 17.75H9l-4.5 2.5.95-3.25A2.24 2.24 0 0 1 3.5 14.78V8.5A2.25 2.25 0 0 1 5.75 6.25Z" />
        <path d="M7.5 10h9M7.5 13.25H13" />
      </>
    ),
    website: (
      <>
        <path d="M12 20.25a8.25 8.25 0 1 0 0-16.5 8.25 8.25 0 0 0 0 16.5Z" />
        <path d="M3.95 12h16.1M12 3.75c2.15 2.25 3.22 5 3.22 8.25S14.15 18 12 20.25C9.85 18 8.78 15.25 8.78 12S9.85 6 12 3.75Z" />
      </>
    ),
  };

  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      {icons[type]}
    </svg>
  );
}

function SettingsPage() {
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(() => isUserLoggedIn());
  const [error, setError] = useState("");
  const [preferences, setPreferences] = useState({
    hideBalances: false,
    compactCards: false,
    enableNotifications: true,
  });
  const navigate = useNavigate();
  const isLoggedIn = isUserLoggedIn();

  useEffect(() => {
    if (!isLoggedIn) {
      setLoading(false);
      return;
    }

    const load = async () => {
      try {
        const data = await fetchUserPortalDetails();
        setDetails(data);
      } catch (err) {
        setError(err.message || "خطا در دریافت اطلاعات تنظیمات");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [isLoggedIn]);

  useEffect(() => {
    try {
      const savedPreferences = localStorage.getItem("userSettings");
      if (savedPreferences) {
        setPreferences((prev) => ({
          ...prev,
          ...JSON.parse(savedPreferences),
        }));
      }
    } catch (err) {
      console.error("Error parsing user settings:", err);
    }
  }, []);

  const user = details?.user;

  const updatePreference = (key) => {
    setPreferences((prev) => {
      const next = {
        ...prev,
        [key]: !prev[key],
      };
      localStorage.setItem("userSettings", JSON.stringify(next));
      return next;
    });
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/");
    window.location.reload();
  };

  return (
    <div className="MainPageShell">
      <TopNavigator />
      <main className="container UserPortalPage">

        <section className="UserPortalPanel">
          {loading ? (
            <p className="UserPortalEmpty">در حال دریافت اطلاعات...</p>
          ) : error ? (
            <p className="UserPortalEmpty UserPortalError">{error}</p>
          ) : (
            <div className="UserSettingsStack">
              {!isLoggedIn && (
                <section className="UserSettingsSection UserSettingsLoginSection">
                  <div className="UserSettingsHeading">
                    <span>ورود</span>
                    <strong>برای دسترسی کامل وارد شوید</strong>
                  </div>
                  <p>
                    برای مشاهده کیف پول، گردش حساب، ثبت حواله و جزئیات حساب باید قبلا وارد حساب کاربری شده باشید.
                  </p>
                  <Link to="/loginpage" className="UserSettingsLoginBtn">
                    ورود به حساب
                  </Link>
                </section>
              )}

              <section className="UserSettingsSection">
                <div className="UserSettingsHeading">
                  <span>تنظیمات سریع</span>
                  <strong>نمایش و اعلان‌ها</strong>
                </div>

                <div className="UserSettingsList">
                  <button
                    type="button"
                    className={preferences.hideBalances ? "UserSettingsToggle active" : "UserSettingsToggle"}
                    onClick={() => updatePreference("hideBalances")}
                  >
                    <span>
                      <strong>مخفی‌کردن موجودی‌ها</strong>
                      <small>برای حفظ حریم خصوصی در محیط عمومی</small>
                    </span>
                    <i aria-hidden="true"></i>
                  </button>

                  <button
                    type="button"
                    className={preferences.compactCards ? "UserSettingsToggle active" : "UserSettingsToggle"}
                    onClick={() => updatePreference("compactCards")}
                  >
                    <span>
                      <strong>نمایش فشرده کارت‌ها</strong>
                      <small>مناسب صفحه‌های کوچک‌تر و مرور سریع</small>
                    </span>
                    <i aria-hidden="true"></i>
                  </button>

                  <button
                    type="button"
                    className={preferences.enableNotifications ? "UserSettingsToggle active" : "UserSettingsToggle"}
                    onClick={() => updatePreference("enableNotifications")}
                  >
                    <span>
                      <strong>اعلان‌های داخل مرورگر</strong>
                      <small>برای تغییر وضعیت معامله و حواله</small>
                    </span>
                    <i aria-hidden="true"></i>
                  </button>
                </div>
              </section>

                  <section className="UserSettingsSection UserSettingsDanger">
                    <div className="UserSettingsHeading">
                      <span>امنیت</span>
                      <strong>خروج از حساب</strong>
                    </div>
                    <p>
                      با خروج، نشست فعلی شما از این دستگاه پاک می‌شود و برای ورود دوباره باید شماره تماس و رمز عبور را وارد کنید.
                    </p>
                    <button type="button" className="UserSettingsLogout" onClick={handleLogout}>
                      خروج از حساب
                    </button>
                  </section>

              <section className="UserSettingsSection UserSettingsSupport">
                <div className="UserSettingsHeading">
                  <span>پشتیبانی</span>
                  <strong>خرید نسخه و دمو رایگان</strong>
                </div>
                <p>
                  برای خرید نسخه و دریافت دمو رایگان با ما تماس بگیرید.
                </p>
                <div className="UserSettingsSupportActions">
                  <a href="tel:09220382792" aria-label="تماس تلفنی">
                    <SupportIcon type="phone" />
                  </a>
                  <a
                    href="https://wa.me/989220382792"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="ارسال پیام واتساپ"
                  >
                    <SupportIcon type="whatsapp" />
                  </a>
                  <a href="sms:09220382792" aria-label="ارسال پیامک">
                    <SupportIcon type="sms" />
                  </a>
                  <a
                    href="https://archavive.com"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="وب‌سایت"
                  >
                    <SupportIcon type="website" />
                  </a>
                </div>
              </section>
            </div>
          )}
        </section>
      </main>
    </div>
  );
}

export default SettingsPage;
